import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CalculadoraService extends ApiService {
    entityType = EntityType.CALCULADORA;
    url = 'api/marketplace/calculadora/';
}
